<template>
  <div class="ExpertStore">
    <MobileNav :page_title="nav_title"></MobileNav>
    <div class="cover-page-container" v-loading="is_expert_details_loading">
      <div class="background-cover">
        <el-card class="box-card profile-card">
          <div class="inner">
            <div class="profile-outer">
              <div class="profile-pic-section relative">
                <img v-if="expert_details.pic" :src="serverHostName + expert_details.pic" class="profile-pic" />

                <img v-else src="../assets/images/navBar/avatar.jpg" class="profile-pic" />
              </div>
            </div>

            <div class="name-details" style="position: relative">
              <div class="flex">
                <div class="font-weight-600" style="font-size: 1.2rem">
                  <div class="section-block" style="display: flex; align-items: center">
                    {{ expert_details.full_name ? expert_details.full_name : '' }}
                    <img src="../assets/images/verify.svg" alt="verified" class="verified" />
                    <el-tooltip v-if="expert_details.mark_as_verified" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
                      <img class="info-Logo cursor-pointer left-margin-5" src="../assets/images/verify.svg" style="width: 16px" alt />
                    </el-tooltip>
                  </div>

                  <div class="section-block profession">
                    {{ expert_details.profession ? expert_details.profession : '' }}
                  </div>

                  <div class="section-block" v-if="expert_details.about_us">
                  <div class="research-info" v-html="expert_details.about_us"></div>
                  </div>

                  <div class="section-block sebi-tag" v-if="expert_details.sebi_regi_number">
                    <div class="sebi-left">
                      SEBI
                      <i class="el-icon-check" style="margin-left: 4px"></i>
                    </div>
                    <div class="sebi-right">
                      {{ expert_details.sebi_regi_number }}
                    </div>
                  </div>
                </div>

                <el-tooltip v-if="expert_details.is_public" class="item" effect="dark" content="Public profile" placement="top">
                  <span class="left-margin-15">
                    <img src="../assets/images/expertHub/published.png" class="cursor-pointer" width="15" />
                  </span>
                </el-tooltip>
              </div>

              <!-- Middle Actions: Positioned inside and aligned -->
              <div class="middle-actions">
                <el-button type="success" class="chat-btn" @click="$router.push('/expert-list')">
                  <img src="../assets/images/chat.svg" alt="" style="width: 16px" />
                  <span style="position: relative; bottom: 2px; margin-left: 5px">Chat</span>
                </el-button>

                <!-- <div class="social-icons">icons</div> -->
                <div class="social-icon-container" v-if="expert_details.gmail || expert_details.facebook || expert_details.linkedin || expert_details.telegram || expert_details.youtube">
                  <a v-if="expert_details.gmail" @click.prevent="redirectToLink(expert_details.gmail)" target="_blank">
                    <img class="social-icon" src="../assets/images/gmail.svg" alt="Gmail" />
                  </a>
                  <a v-if="expert_details.facebook" @click.prevent="redirectToLink(expert_details.facebook)" target="_blank">
                    <img class="social-icon" src="../assets/images/facebook.png" alt="Facebook" />
                  </a>
                  <a v-if="expert_details.linkedin" @click.prevent="redirectToLink(expert_details.linkedin)" target="_blank">
                    <img class="social-icon" src="../assets/images/linkedin.png" alt="LinkedIn" />
                  </a>
                  <a v-if="expert_details.telegram" @click.prevent="redirectToLink(expert_details.telegram)" target="_blank">
                    <img class="social-icon" src="../assets/images/telegram.svg" alt="Telegram" />
                  </a>
                  <a v-if="expert_details.youtube" @click.prevent="redirectToLink(expert_details.youtube)" target="_blank">
                    <img class="social-icon" src="../assets/images/Youtube Icon.png" alt="YouTube" />
                  </a>
                </div>
              </div>
            </div>
            <div class="expertise-wrapper">
              <!-- <el-button class="btn-secondary-theme-borderd" size="mini" @click="getRecoByExpert()">Check opinions</el-button>

              <el-button class="btn-secondary-theme-filled" size="mini" v-if="(!Object.keys(subscribedPlanDetails).length || subscribedPlanDetails.plan == 'Lite') && !expert_details.is_public && expert_details.plan_name == 'Pro'" @click="access_code_dialog_visibility = true">Use Access Code</el-button> -->
              <!-- Expertise Section -->
              <div class="expertise-title">
                <img src="../assets/images/Expertise Icon (2).svg" alt="" style="width: 25px" />
                Expertise
              </div>
              <div class="expertise-tags">
                <div v-for="tag in ['Technical', 'Fundamental', 'Future & Options', 'Technical Analysis']" :key="tag" class="expertise-tag">
                  {{ tag }}
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>

      <div class="about-section">
        <el-card class="box-card about-us-card reco-card-section">
          <div class="card-bg-top">
            <div class="banner-content">
              <div class="left-content">
                <img src="../assets/images/chat.svg" alt="Chat Icon" class="chat-icon" />
                <div>
                  <h1>
                    Got
                    <span class="highlight">Doubts?</span>
                  </h1>
                  <p>I’ve Got Insights. Stay Hungry, Stay Learning.</p>
                </div>
              </div>

              <div class="middle-text">
                <ul>
                  <li>
                    <i class="el-icon-check"></i>
                    Live 15min Chat
                  </li>
                  <li>
                    <i class="el-icon-check"></i>
                    Pay and Connect Instantly
                  </li>
                  <li>
                    <i class="el-icon-check"></i>
                    Real Time Guidance
                  </li>
                </ul>
              </div>

              <div class="right-content">
                <button class="ask-now" @click="$router.push('/expert-list')">Ask Now</button>
              </div>
            </div>
          </div>

          <div class="RA-recommendations">
            <LatestRecommendations :recommendations="latestRecos" :isRecoListLoading="isRecoListLoading" @get_reco_details="recoDetails" />
          </div>
        </el-card>

        <el-row class="expert-buzz-feed">
          <div class="ExpertBuzz-header">
            ExpertBuzz Feed
            <span class="view-all" @click="$router.push({ path: '/expert-buzz', query: { profile_id: $route.query.user_id || '', name: $route.query.name || '' } })">View all ({{ totalPostCount }})</span>
          </div>
          <ExpertCommunityPost :posts="communityPosts" />
        </el-row>

        <el-card class="about-us-card" style="width: 100%">
          <div class="flex-space-between font-09rem font-weight-600">
            <div class="flex">
              <img src="../assets/images/myAccount/grp_login.png" style="height: 19px; margin-right: 10px" />
              Reviews
            </div>

            <el-button class="btn-theme-borderd" size="mini" v-if="user_id != userProfile.id" @click="openReviewDialog()">WRITE REVIEW</el-button>
          </div>

          <div class="top-margin-10">
            <div class="bottom-margin-10" v-for="(review, review_index) in review_list" :key="review_index" :style="[review_index < review_list.length - 1 ? { borderBottom: '1px solid #f1f1f1' } : '']">
              <div style="display: flex; padding: 10px">
                <!-- <div class="profile-pic"> -->
                <img :src="serverHostName + review.profile_pic" v-if="review.profile_pic" class="profile-pic" style="width: 45px; height: 45px" />

                <img src="../assets/images/navBar/avatar.jpg" v-else class="profile-pic" style="width: 45px; height: 45px" />

                <div>
                  <div class="font-08rem capitalize font-weight-600 left-margin-15 line-height-1-5">
                    {{ review.name }}
                  </div>

                  <div class="font-06rem font-weight-500 left-margin-15 line-height-1-5" style="color: #979797">
                    {{ review.designation }}
                  </div>

                  <!-- <el-rate class="left-margin-15" :allow-half="true" v-model="review.rating" disabled></el-rate> -->
                </div>
              </div>

              <div style="padding: 10px">
                <div class="font-08rem font-weight-600 secondary-theme-color">"{{ review.review_title }}"</div>

                <div class="font-07rem">
                  {{ review.review }}
                </div>

                <div class="font-07rem top-margin-5" style="color: #a7a7a7">
                  <span><i class="el-icon-time"></i></span>
                  &nbsp;&nbsp;{{ moment(review.date).format('DD MMM YYYY HH:mm a') }}
                </div>
              </div>

              <div style="padding: 5px 10px" v-for="(user, user_index) in review.replied_users" :key="user_index" :style="[user_index < review.replied_users.length ? { borderTop: '1px solid #f1f1f1' } : '']">
                <div class="font-08rem capitalize font-weight-500 line-height-1-5">
                  {{ user.created_by.first_name }}
                  {{ user.created_by.last_name }}
                </div>

                <div class="font-07rem">
                  {{ user.comment }}
                </div>
              </div>
            </div>

            <div class="font-08rem font-weight-500 top-margin-10 primary-theme-color text-center top-margin-20 bottom-margin-20" v-if="!review_list.length">No data available</div>

            <el-pagination class="label-xs-bold text-center top-margin-10" small v-if="total_review_pages > 1 && review_list.length" :current-page.sync="review_current_page_no" @current-change="handleReivewPageCurrentPageChange" :page-size="review_per_page" layout="prev, pager, next" :total="total_reviews"></el-pagination>
          </div>
        </el-card>

        <el-card class="box-card about-us-card" style="width: 100%">
          <div class="flex-space-between font-09rem font-weight-600">
            <div class="flex">
              <img src="../assets/images/myAccount/grp_login.png" style="height: 19px; margin-right: 10px" />
              Disclosure & Disclaimer
            </div>

            <el-button size="mini" style="background-color: #e7f3fe; color: #4482cd; font-weight: 600; padding: 5px" @click="downloadDisclosure">
              <span style="display: flex; align-items: center">
                <img src="../assets/images/Download icon (2).svg" alt="Download" style="height: 14px; font-weight: 22" />
              </span>
            </el-button>
          </div>
          <div class="disclaimer" style="font-size: 12px; font-weight: 500; margin-top: 12px; color: #969696">Disclaimer: Investing in Stocks/ETFs (Exchange Traded Funds) are subject to market risks. Read all the related documents before investing. Investors should consider all risk factors and consult their financial advisor before investing.</div>
        </el-card>
      </div>

      <!-- write review dialog -->
      <div class="review-dialog">
        <el-dialog title="Write your review" :visible.sync="write_review_dialog_visibility" :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="true" class="review-dialog-box" :before-close="closeWriteReviewDialog">
          <div>
            <el-row :gutter="15">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': review_title.length,
                    'form-group--error': $v.review_title.$error,
                  }"
                >
                  <div class="sub-title bottom-margin-5 inline-block">Review title</div>
                  &nbsp;
                  <span class="required-field">*</span>
                  <el-input placeholder="Title" v-model="review_title" size="small"></el-input>
                </div>

                <div class="error" v-if="!$v.review_title.required">Field is required</div>
              </el-col>
            </el-row>

            <el-row :gutter="15" class="top-margin-15">
              <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                <div
                  class="form-group"
                  :class="{
                    'not-empty': review.length,
                    'form-group--error': $v.review.$error,
                  }"
                >
                  <div class="sub-title bottom-margin-5 inline-block">Write a review</div>
                  &nbsp;
                  <span class="required-field">*</span>

                  <el-input type="textarea" resize="none" v-model="review" cols="30" rows="5" maxlength="200" placeholder="Max 200 words"></el-input>
                </div>

                <div class="error" v-if="!$v.review.required">Field is required</div>
              </el-col>
            </el-row>

            <div class="top-margin-15" style="display: flex">
              <el-checkbox v-model="checked" class="right-margin-10"></el-checkbox>
              <div class="font-07rem" style="text-align: justify">I certify that this review is based on my own experience and is my genuine opinion for this expert and that I have not been offered anyincentive and payment originating from the establishment to write this review. I understand that StockAnts has a zero-tolerance policy on fake reviews.</div>
            </div>
          </div>
          <div class="top-margin-20">
            <el-button round class="btn-theme-borderd" size="mini" @click="submitReview()" :disabled="!review_title || !review || !checked" :loading="is_review_submit_in_progress">SUBMIT</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- access code dialog -->
    <el-dialog title="Access Code" :visible.sync="access_code_dialog_visibility" :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="true" class="access-code-dialog" :before-close="closeAccessCodeDialog">
      <div class="flex-center">
        <el-input class="access-code-input" placeholder="Enter access code (Optional)" v-model="access_code" size="small"></el-input>
        <el-button round class="btn-theme-borderd left-margin-10" size="small" :loading="is_access_code_verifying" :disabled="!access_code" @click="validateAccessCode()">SUBMIT</el-button>
      </div>
    </el-dialog>

    <StockDialog v-if="isStockDetailsDialogVisible" :isStockDetailsDialogVisible.sync="isStockDetailsDialogVisible" :reco_data="reco_data" />
  </div>
</template>

<script>
var echarts = require('echarts');
import { serverAddr, serverHostName } from '../networkConfig';
import { filterCallBack } from '../mixins/filter';
import { screenSize } from '../mixins/ScreenSize.js';
import PlainSideBar from '@/components/PlainSideBar.vue';
import MobileNav from '@/components/MobileNav.vue';
import CripNotice from 'crip-vue-notice';
import NoDataFound from '@/components/NoDataFound.vue';
import Hexagon from '@/components/Hexagon.vue';
import ExpertHubProfileCard from '@/components/ExpertHubProfileCard.vue';
import { required } from 'vuelidate/lib/validators';
import { graphData } from '../mixins/BarGraphData';
import { HelperNetworkCallBack } from '../mixins/Helper';
import moment from 'moment';
import axios from 'axios';
import { EventBus } from '../eventBus';
import jsPDF from 'jspdf';
import ExpertCommunityPost from '../components/ExpertCommunityPost.vue';
import LatestRecommendations from '../components/LatestRecommendations.vue';
import Trade from '@/components/Trade.vue';
import StockDialog from '@/components/StockDialog.vue';

export default {
  name: 'ExpertStore',

  mixins: [filterCallBack, screenSize, graphData, HelperNetworkCallBack],

  components: {
    ExpertHubProfileCard,
    Hexagon,
    PlainSideBar,
    MobileNav,
    NoDataFound,
    ExpertCommunityPost,
    LatestRecommendations,
    Trade,
    StockDialog,
  },

  data() {
    return {
      nav_title: 'Expert Cover Page',
      expert_details: {},
      user_id: '',
      user_type: '',
      // user_profession: [],
      is_following: false,
      write_review_dialog_visibility: false,
      access_code_dialog_visibility: false,
      is_review_section_loading: false,
      review_per_page: 3,
      total_review_pages: null,
      review_current_page_no: 1,
      total_reviews: null,
      access_code: '',
      is_expert_has_access_to_dashboard: false,
      is_access_code_verifying: false,
      star_rating: null,
      review_title: '',
      review: '',
      checked: false,
      review_section_collapse: 1,
      is_expert_details_loading: false,
      is_review_submit_in_progress: false,
      review_list: [],
      page_no: 1,
      number_of_pages: null,
      page_per_entries: 3,
      active_carousel_item: 0,
      active_sub_menu_link: 'STOCKS',
      active_performance: 'SUCCESS_RATE',
      active_period: '1M',
      is_roi_graph_data_available: true,
      is_success_rate_graph_data_available: true,
      is_accuracy_graph_data_available: true,
      is_reco_count_data_available: true,
      roi_graph_instance: null,
      accuracy_graph_instance: null,
      success_rate_graph_instance: null,
      reco_count_graph_instance: null,
      active_roi_inner_chart_legend: '',
      active_roi_outer_chart_legend: '',
      active_accuracy_inner_chart_legend: '',
      active_accuracy_outer_chart_legend: '',
      active_success_rate_inner_chart_legend: '',
      active_success_rate_outer_chart_legend: '',
      active_reco_count_chart_legend: '',
      total_stocks_covered: 0,
      moment: moment,
      serverHostName: serverHostName,
      userProfile: JSON.parse(localStorage.getItem('profile')),
      isRecoListLoading: false,
      isCommunityPostsLoading: false,
      communityPosts: [],
      page_no: 1,
      isRecoListLoading: false,
      serverHostName: serverHostName,
      reco_data: {},
      latestRecos: [],
      websiteUserType: {},
      userProfile: {},
      isDataChanged: false,
      planSubscriptionStatusDetails: null,
      isStockDetailsDialogVisible: false,
      totalPostCount: 0,
    };
  },

  validations: {
    review_title: {
      required,
    },
    review: {
      required,
    },
    access_code: {
      required,
    },
  },

  beforeRouteEnter(to, from, next) {
    let user_id = from.query.user_id ? from.query.user_id : to.query.user_id ? to.query.user_id : null;

    // if user is logged in user then redirect it to dashboard analytics page
    if (user_id) {
      if (JSON.parse(localStorage.getItem('profile')).profile_id == user_id) {
        next({ name: 'dashboardAnalytics' });
      }
    }

    next();
  },

  created() {
    // checked is user has validated access code
    // checked that validated access code of expert and current selected expert both are same
    // do not check this condition in computed -- localstorage will not reactive
    if (localStorage.getItem('access_to_expert_dashboard') == this.user_id) {
      this.is_expert_has_access_to_dashboard = true;
    }
    if (!localStorage.getItem('currentEnvironment')) {
      this.selectUserType();
    }
    this.userProfile = JSON.parse(localStorage.getItem('profile'));
  },

  mounted() {
    if (this.userProfile.profession == 'Retail Investor') {
      this.active_performance = 'SUCCESS_RATE';
    }
    if (this.$store.state.dashboardActivePeriod) {
      this.active_period = this.$store.state.dashboardActivePeriod;
    }

    if (this.$route.query.user && this.$route.query.user_id) {
      this.user_type = this.$route.query.user;
      this.user_id = this.$route.query.user_id;
      // this.user_profession = this.$route.query.profession;

      // this.selectPeriod("1M");
      this.getExpertsAbout();
      this.fetchAllData();
    }

    // select user type for navigation access
    if (localStorage.getItem('websiteUserType')) {
      this.websiteUserType = JSON.parse(localStorage.getItem('websiteUserType'));
    }
  },

  methods: {
    recoDetails(reco, action) {
      var reco_id = reco.id;

      serverAddr
        .post('recommendation/v1/read_recommendation', { id: reco_id })
        .then((response) => {
          if (response.data && response.data.status) {
            let data = response.data.data;

            this.reco_data = data[0];

            if (action == 'recoPopup') {
              if (this.reco_data.brokerage_data && this.reco_data.brokerage_data.IntraDay) {
                this.reco_data.brokerage_list_type = 'IntraDay';
                this.$set(this.reco_data, 'selected_brokerage_list', this.reco_data.brokerage_data.IntraDay[0].data);
                this.$set(this.reco_data, 'brokerage_list_type', 'IntraDay');
                this.$set(this.reco_data, 'reco_quantity', 1);
                this.$set(this.reco_data, 'logic_description', this.reco_data.report.length ? this.reco_data.report[0].description : '');

                if (this.reco_data.brokerage_data.IntraDay[0].exp_tax) {
                  this.$set(this.reco_data, 'exp_tax', this.reco_data.brokerage_data.IntraDay[0].exp_tax);
                } else {
                  this.$set(this.reco_data, 'exp_tax', this.reco_data.brokerage_data.IntraDay[0].data.total_tax_and_charges);
                }
              }
              // Open StockDialog with the filtered reco_data
              this.isStockDetailsDialogVisible = true;
            } else {
              this.openTradePopup(this.reco_data);
            }
          } else {
            console.error('Failed to fetch recommendation details:', response.data.message);
          }
        })
        .catch((error) => {
          console.error('API Error:', error);
        })
        .finally(() => {
          this.isRecoListLoading = false;
        });
    },
    openTradePopup(stockDetails) {
      var stockData = {};
      stockData.segment = 'equity';
      stockData.symbol = stockDetails.stock.symbol;
      stockData.stock_id = stockDetails.stock.id;
      stockData.stop_loss = stockDetails.stop_loss;
      stockData.target_price = stockDetails.target_price;
      stockData.order_type = stockDetails.reco;
      stockData.entry_price = stockDetails.reco_open_price;
      stockData.ltp = stockDetails.stock.current_price;
      stockData.duration = stockDetails.duration;
      stockData.name = stockDetails.stock.name;

      if (this.isTradeVisible()) {
        if (stockDetails.reco == 'Buy') {
          // set parameters for pre selected stock in trade button
          this.$store.commit('commitTradeMenu', 'TRADE');
          this.$store.commit('commitSelectedOrder', stockData);
          this.$store.commit('tradePopupAction', true);
          this.isDataChanged = true;
        } else if (stockDetails.reco == 'Sell') {
          this.isVisibleSellNotAllowedPopup = true;
        }
      } else {
        if (this.websiteUserType.userType != 'broker') {
          this.$store.commit('commitBrokerLoginDialogVisibility', true);
          this.$store.commit('commitSelectedOrder', stockData);
        } else {
          this.$store.commit('commitSubscribPlanDialogVisibility', true);
        }
      }
    },

    handleClose() {
      this.isDataChanged = false;
      this.$store.commit('tradePopupAction', false);
    },

    async fetchAllData() {
      this.isRecoListLoading = true;

      try {
        const [latestRecommendation, communityPosts] = await Promise.allSettled([
          this.getLatestRecommendation(),
          this.getAllCommunityPosts(this.page_no),
          // ...other API calls if needed
        ]);

        if (latestRecommendation.status === 'fulfilled') {
          var data = latestRecommendation.value.data;
          if (data.status) {
            this.latestRecos = data.data.slice(0, 3).map((item) => ({
              reco: item.reco,
              created_at: item.created_at,
              remaining_potential: item.remaining_potential,
              stock_name: item.stock_name,
              user_detail: item.user_detail,
              risk_tag: item.risk_tag,
              stock_logo: item.stock_logo,
              id: item.id,
            }));
          }
        } else {
          console.error('Failed to fetch latest recommendations:', latestRecommendation.reason);
        }

        if (communityPosts.status === 'fulfilled') {
          var posts = communityPosts.value.data.data;
          this.totalPostCount = communityPosts.value.data.pagination && communityPosts.value.data.pagination.total_entries ? communityPosts.value.data.pagination.total_entries : 0;
          this.communityPosts = posts.length >= 3 ? posts.slice(0, 3) : posts;
          //  console.log(this.communityPosts);
        } else {
          console.error('Failed to fetch community posts:', communityPosts.reason);
        }
      } catch (error) {
        console.error('Error in fetchAllData:', error);
      } finally {
        this.isRecoListLoading = false;
      }
    },

    async getLatestRecommendation() {
      return serverAddr
        .get(`/recommendation/v1/latest_recommendation?expert_id=${this.user_id}`)
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    async getAllCommunityPosts(page = 1) {
      let userId = this.$route.query.user_id;
      let apiUrl = `/community/community-post?page_number=${page}&page_per_entries=5`;

      if (userId) {
        apiUrl += `&profile_id=${userId}`;
      }

      try {
        const response = await serverAddr.get(apiUrl);
        return response;
      } catch (error) {
        console.error('Error fetching community posts:', error);
        return null;
      }
    },
    getBorderColor(risk_tag) {
      if (risk_tag === 'low') return '#67C23A';
      if (risk_tag === 'medium') return '#E6A23C';
      if (risk_tag === 'high') return '#F56C6C';
      return '#909399';
    },
    getButtonColor(reco) {
      if (reco === 'BUY') return '#0BA042';
      if (reco === 'SELL') return '#EA2526';
      return '#909399';
    },
    openStockPopup(recommendation, type) {
      console.log('Clicked:', recommendation, 'Type:', type);
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    },

    getRecoByExpert() {
      // checked subscribed plan has access to this filter
      //restricted filters to access for expert section if trial plan is subscribed
      //same component is being used on user and expert section
      if (!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite') {
        this.$store.commit('commitSubscribPlanDialogVisibility', true);
        return;
      }

      var market_type = localStorage.getItem('market_type') ? localStorage.getItem('market_type') : 'equity';

      if (market_type == 'equity') {
        this.$router.push({
          path: `/experts-past-recommendations?user_id=${this.user_id}`,
        });
      } else {
        this.$router.push({
          path: `/expert-past-strategy-options?user_id=${this.user_id}`,
        });
      }
    },

    validateAccessCode() {
      if (this.access_code) {
        this.is_access_code_verifying = true; //enabled loader

        serverAddr
          .post(`/expert/has_access/`, {
            access_code: this.access_code,
            target_user_type: this.user_type == 'individual' ? 1 : this.user_type == 'company' ? 2 : '',
            target_user_id: this.user_id,
          })
          .then((response) => {
            if (response.data.status) {
              localStorage.setItem('access_to_expert_dashboard', this.user_id);

              this.is_expert_has_access_to_dashboard = true; //to enable access to dashboard

              // after successfully validation redirect user to expert dashboard page
              this.$router.push({
                name: 'expertDashboard',
                query: {
                  user_id: this.user_id,
                  user: this.user_type,
                  name: this.expert_details.full_name,
                },
              });

              new CripNotice({
                title: 'Success',
                description: 'Access code verified!',
                type: 'success',
                duration: 3,
              });
            } else {
              new CripNotice({
                title: 'Error',
                description: 'Invalid access code!',
                type: 'error',
                duration: 3,
              });
            }

            this.access_code = '';
            this.access_code_dialog_visibility = false; //closed dialog
            this.is_access_code_verifying = false; //disabled loader
          })
          .catch(
            function (error) {
              console.log(error);

              this.access_code_dialog_visibility = false; //closed dialog

              this.is_access_code_verifying = false; //disabled loader

              new CripNotice({
                title: 'Error',
                description: 'Something went worng..!',
                type: 'error',
                duration: 3,
              });
            }.bind(this)
          );
      }
    },

    async handleReivewPageCurrentPageChange() {
      this.is_review_section_loading = true; //enabled loader
      this.review_list = [];

      let review_res = await this.getAllReviews();

      if (review_res.data.status && review_res.data.data.length) {
        review_res.data.data.forEach((e) => {
          let obj = {};
          (obj.profile_pic = e.pic), (obj.name = e.created_by.first_name + ' ' + e.created_by.last_name), (obj.designation = e.creator_profession), (obj.rating = e.rating), (obj.review_title = e.title), (obj.review = e.comment), (obj.date = e.review_date), (obj.replied_users = e.replied_users);

          this.review_list.push(obj);
        });

        this.total_review_pages = review_res.data.pagination.total_pages;
        this.total_reviews = review_res.data.pagination.total_entries;
        this.review_current_page_no = review_res.data.pagination.current_page;

        this.is_review_section_loading = false; //disabled loader
      }
    },

    openReviewDialog() {
      this.review_title = '';
      this.review = '';
      this.checked = false;
      this.write_review_dialog_visibility = true;
    },

    closeAccessCodeDialog() {
      this.access_code_dialog_visibility = false;
    },

    closeWriteReviewDialog() {
      this.write_review_dialog_visibility = false;
    },

    combinedApis() {
      this.review_list = [];
      axios
        .all([this.getAllReviews(), this.getUserRating()])
        .then(
          axios.spread((reviewList, userRatingRes) => {
            // for review details
            if (reviewList.data.status && reviewList.data.data.length) {
              reviewList.data.data.forEach((e) => {
                let obj = {};
                (obj.profile_pic = e.pic), (obj.name = e.created_by.first_name + ' ' + e.created_by.last_name), (obj.designation = e.creator_profession), (obj.rating = e.rating), (obj.review_title = e.title), (obj.review = e.comment), (obj.date = e.review_date), (obj.replied_users = e.replied_users);

                this.review_list.push(obj);
              });

              this.total_review_pages = reviewList.data.pagination.total_pages;
              this.total_reviews = reviewList.data.pagination.total_entries;
              this.review_current_page_no = reviewList.data.pagination.current_page;
            }

            if (userRatingRes.data.status) {
              this.star_rating = userRatingRes.data.data.rating;
            }
            this.is_expert_details_loading = false; //enabled loader
          })
        )
        .catch((err) => {
          console.log(err);
          this.is_expert_details_loading = false; //enabled loader
          this.review_list = [];
        })
        .finally(() => {
          this.is_expert_details_loading = false; //enabled loader
        });
    },

    getRecommendationCount() {
      let url = '';

      if (this.active_sub_menu_link == 'STOCKS') {
        url = '/my_dashboard/v1/stock/period_based_roi';
      } else {
        url = '/my_dashboard/v1/sector/period_based_roi';
      }

      return serverAddr
        .post(url, {
          user_id: Number(this.user_id),
          period: this.active_period,
        })
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);

            this.is_reco_count_data_available = false;

            this.reco_count_series[0].data = [];

            this.reco_count_graph_instance.hideLoading(this.loader_default); //disabled loader

            this.reRenderRecoCountGraphInstance();
          }.bind(this)
        );
    },

    async submitReview() {
      this.$v.$touch();
      if (this.review_title && this.review && this.checked) {
        this.is_review_submit_in_progress = true; //enabled button loader

        let params = {
          title: this.review_title,
          comment: this.review,
          response_type: this.user_type,
          reviewed_user: this.user_id,
        };

        serverAddr
          .post('/expert/v1/review/', params)
          .then(async (response) => {
            if (response.data.status) {
              new CripNotice({
                title: 'Success',
                description: 'Review submitted',
                type: 'success',
                duration: 3,
              });

              this.is_review_section_loading = true; //enabled loader

              // after submitting reivew calleg get all reviews api to show updated review
              let review_res = await this.getAllReviews();

              if (review_res.data.status && review_res.data.data.length) {
                this.review_list = [];

                review_res.data.data.forEach((e) => {
                  let obj = {};
                  (obj.profile_pic = e.pic), (obj.name = e.created_by.first_name + ' ' + e.created_by.last_name), (obj.designation = e.creator_profession), (obj.rating = e.rating), (obj.review_title = e.title), (obj.review = e.comment), (obj.date = e.review_date), (obj.replied_users = e.replied_users);

                  this.review_list.push(obj);
                });

                this.total_review_pages = review_res.data.pagination.total_pages;
                this.total_reviews = review_res.data.pagination.total_entries;
                this.review_current_page_no = 1;
              }
            }

            this.is_review_submit_in_progress = false; //disabled button loader

            this.is_review_section_loading = false; //disabled loader

            this.write_review_dialog_visibility = false; //closed review dialog
          })
          .catch(
            function (error) {
              console.log(error);
              this.is_review_submit_in_progress = false; //disabled button loader
              this.is_review_section_loading = false; //disabled loader
            }.bind(this)
          );
      }
    },

    // api to get all revies
    getAllReviews() {
      return serverAddr
        .get(`/expert/v1/review/?reviewed_user=${this.user_id}&response_type=${this.user_type}&page_number=${this.review_current_page_no}&page_per_entries=${this.review_per_page}`)
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    // api to get rating
    getUserRating() {
      return serverAddr
        .get(`/expert/v1/rating/?rating_user=${this.user_id}&response_type=${this.user_type}`)
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    getExpertsAbout() {
      this.is_expert_details_loading = true;
      return serverAddr
        .get(`/auth/v1/me/${this.user_id}`)
        .then((response) => {
          let expertsMetaDataRes = response;
          if (expertsMetaDataRes.data.status) {
            this.expert_details.pic = expertsMetaDataRes.data.data.pic ? expertsMetaDataRes.data.data.pic : '';
            this.expert_details.gmail = expertsMetaDataRes.data.data.gmail;
            this.expert_details.facebook = expertsMetaDataRes.data.data.facebook;
            this.expert_details.linkedin = expertsMetaDataRes.data.data.linkedin;
            this.expert_details.full_name = expertsMetaDataRes.data.data.full_name;
            this.expert_details.profession = expertsMetaDataRes.data.data.profession;
            this.expert_details.twitter = expertsMetaDataRes.data.data.twitter;
            this.expert_details.telegram = expertsMetaDataRes.data.data.telegram;
            this.expert_details.youtube = expertsMetaDataRes.data.data.youtube;
            this.expert_details.follow_option_enable = expertsMetaDataRes.data.data.follow_option_enable;
            this.expert_details.is_public = expertsMetaDataRes.data.data.is_public;
            this.expert_details.plan_name = expertsMetaDataRes.data.sub_plan_data.plan;
            this.expert_details.following = expertsMetaDataRes.data.data.following;
            this.expert_details.followers = expertsMetaDataRes.data.data.followers;
            this.expert_details.sebi_regi_number = expertsMetaDataRes.data.data.sebi_regi_number;
            if (this.user_id == 380 || this.user_id == 411 || this.user_id == 385 || this.user_id == 382 || this.user_id == 415 || this.user_id == 616) {
              this.expert_details.about_us = '';
            } else {
              this.expert_details.about_us = expertsMetaDataRes.data.data.about_us;
            }
          }
          this.combinedApis();
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    sendVisitorsTrackToServer() {
      return serverAddr
        .post(`/expert/v1/visitors_track/`, {
          expert: this.user_id,
          response_type: this.user_type,
        })
        .then((response) => {
          return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    sendDashboardAccessTrackToServer() {
      serverAddr
        .post(`/expert/past_reco_access_track/`, {
          expert: this.user_id,
          response_type: this.user_type,
        })
        .then((response) => {
          // return response;
        })
        .catch(
          function (error) {
            console.log(error);
          }.bind(this)
        );
    },

    //follow expert api
    followExpert() {
      // if user type is company then sent company id other wise user ids
      if (this.user_id != undefined && this.user_id != null) {
        let followList = [];
        let company = [];
        let obj = {};

        this.is_following = true; //enabled loader

        if (this.expert_details.follow_option_enable) {
          obj.status = false; //if followed
        } else {
          obj.status = true; //if not followed
        }

        if (this.user_type == 'company') {
          obj.company_id = this.user_id;
          company.push(obj);
        } else {
          obj.user_id = this.user_id;
          followList.push(obj);
        }

        serverAddr
          .post('/stockants/add-to-favroite/', {
            favroite: [],
            followers: followList,
            company: company,
          })
          .then(
            async function (response) {
              if (response.data.status) {
                if (this.expert_details.follow_option_enable) {
                  this.expert_details.follow_option_enable = false; //if already added to follow list
                  new CripNotice({
                    title: 'Success',
                    description: 'Unfollowed',
                    type: 'success',
                    duration: 3,
                  });
                } else {
                  this.expert_details.follow_option_enable = true; //if not added in follow list
                  new CripNotice({
                    title: 'Success',
                    description: 'Followed',
                    type: 'success',
                    duration: 3,
                  });
                }

                this.is_following = false; //disabled loader

                // called api to show updated followers on side bar
                let expert_details = await this.getExpertDetails();

                if (expert_details.data.status && expert_details.data.data.length) {
                  let obj = {
                    picture: expert_details.data.data[0].pic,
                    name: expert_details.data.data[0].name,
                    rank: expert_details.data.data[0].rank,
                    profession: expert_details.data.data[0].profession,
                    company: expert_details.data.data[0].user_company_name,
                    accuracy: expert_details.data.data[0].accuracy,
                    success_rate: expert_details.data.data[0].success_rate,
                    annual_roi: expert_details.data.data[0].annual_roi,
                    live_reco: expert_details.data.data[0].live_reco,
                    total_reco: expert_details.data.data[0].total_reco,
                    total_reco_day: expert_details.data.data[0].total_reco_day,
                    overall_rating: expert_details.data.data[0].overall_rating,
                    following: expert_details.data.data[0].following,
                    follower: expert_details.data.data[0].follower,
                  };

                  // stored expert deails in store to show details on sidebar
                  this.$store.commit('commitExpertDetails', obj);
                }
              } else {
                this.is_following = false; //disabled loader
              }
            }.bind(this)
          )
          .catch((error) => {
            console.log(error);
            this.is_following = false; //disabled loader
          });
      }
    },

    downRecoCountChart(params) {
      this.reco_count_graph_instance.dispatchAction({
        type: 'hideTip',
      });

      this.reco_count_graph_instance.dispatchAction({
        type: 'downplay',
        // seriesIndex: index,
      });
    },

    redirectToLink(link) {
      if (link.includes('https://') || link.includes('http://')) {
        window.open(link);
      } else if (!link.includes('https://') || !link.includes('http://')) {
        let str = 'https://' + link;
        window.open(str);
      } else {
        window.open(link);
      }
    },

    downloadDisclosure() {
      const { full_name, sebi_regi_number, contact, gmail, company_name, registered_address, profession } = this.expert_details;
      const doc = new jsPDF();

      const marginX = 20;
      let marginY = 20;
      const lineHeight = 10;
      const reducedLineHeight = 7;
      const dash = '-';

      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');
      doc.text('SEBI Expert Disclosure', marginX, marginY);
      marginY += 2 * lineHeight;

      doc.setFontSize(12);
      const addDetail = (label, value) => {
        doc.setFont('helvetica', 'bold');
        doc.text(`${label}: `, marginX, marginY);
        doc.setFont('helvetica', 'normal');
        doc.text(`${value || dash}`, marginX + 70, marginY);
        marginY += lineHeight;
      };

      addDetail('SEBI Expert Registered Name', full_name);
      addDetail('SEBI Expert Registration Number', sebi_regi_number);
      addDetail('Contact Number', contact);
      addDetail('Email', gmail);
      addDetail('Company Name', company_name);
      addDetail('Registered Address', registered_address);
      marginY += 1 * lineHeight;

      doc.setFont('helvetica', 'bold');
      doc.text('Disclaimer', marginX, marginY);
      marginY += lineHeight;

      doc.setFont('helvetica', 'normal');
      const disclaimer = [
        'The content provided by SEBI-registered experts on StockAnts is for informational purposes only and should not be considered as personalized financial advice. SEBI Registered Experts on our platform are qualified and experienced, but do not guarantee the accuracy, completeness, or timeliness of the information they provide.',
        "It is important to note that the sample displayed on StockAnts is only a small portion of the expert's overall expertise.",
        'The information presented above reflects the actual (as-is) performance based on the data shared by SEBI experts on StockAnts. Past performance does not guarantee future returns and performances of the portfolios are subject to market risk.',
        'Investment in securities involves inherent risks, and the performance of any investment can be influenced by various factors, including market conditions, economic trends, and company-specific events. Investors should understand that their investment decision is based on personal investment needs and risk tolerance, and information present in the material prepared by the company and on the website of the company is one among many other things that should be considered while making an investment decision.',
        'Registration granted by SEBI, membership of BASL (in case of IAs) and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.',
        'StockAnts or any SEBI Expert does not provide any promise or assurance of a favorable view for a particular industry, sector, or business group in any manner. Investors are requested to take into consideration all the risk factors, including their financial condition, suitability to risk-return profile, and seek professional advice before investing.',
        'StockAnts is a technology support platform for SEBI Experts to support retail users for investment decision-making and does not promote products or services of any SEBI registered intermediary directly or indirectly.',
      ];

      disclaimer.forEach((text, index) => {
        const formattedText = `${index + 1}. ${text}`;
        const splitText = doc.splitTextToSize(formattedText, 170);
        doc.text(splitText, marginX, marginY);
        marginY += splitText.length * reducedLineHeight;
      });

      doc.addPage();
      marginY = 30;
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text(full_name || dash, 105, marginY, { align: 'center' });
      marginY += lineHeight;

      doc.setFontSize(14);
      doc.text(profession || dash, 105, marginY, { align: 'center' });
      marginY += lineHeight;

      doc.setFont('helvetica', 'bold');
      doc.text('Address: ', marginX, marginY);
      doc.setFont('helvetica', 'normal');
      doc.text(registered_address || dash, marginX + 25, marginY);
      marginY += lineHeight * 2;

      doc.setFont('helvetica', 'bold');
      doc.text('E-mail: ', marginX, marginY);
      doc.setFont('helvetica', 'normal');
      doc.text(gmail || dash, marginX + 20, marginY);

      doc.setFont('helvetica', 'bold');
      doc.text('Contact No.: ', 140, marginY);
      doc.setFont('helvetica', 'normal');
      doc.text(contact || dash, 170, marginY);
      marginY += lineHeight * 2;

      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.text('Most Important Terms and Conditions (MITC)', marginX, marginY);
      marginY += lineHeight;

      doc.setFontSize(12);
      doc.setFont('helvetica', 'normal');
      const terms = [
        '1. These terms and conditions, and consent thereon are for the research services provided by the Research Analyst (RA) and RA cannot execute/carry out any trade (purchase/sell transaction) on behalf of, the client. Thus, the clients are advised not to permit RA to execute any trade on their behalf.',
        '2. The fee charged by RA to the client will be subject to the maximum of amount prescribed by SEBI/ Research Analyst Administration and Supervisory Body (RAASB) from time to time (applicable only for Individual and HUF Clients).',
        '   2.1. The current fee limit is Rs 1,51,000/- per annum per family of client for all research services of the RA.',
        '   2.2. The fee limit does not include statutory charges.',
        '   2.3. The fee limits do not apply to a non-individual client / accredited investor.',
        '3. RA may charge fees in advance if agreed by the client. Such advance shall not exceed the period stipulated by SEBI; presently it is one quarter. In case of pre-mature termination of the RA services by either the client or the RA, the client shall be entitled to seek refund of proportionate fees only for unexpired period.',
        '4. Fees to RA may be paid by the client through any of the specified modes like cheque, online bank transfer, UPI, etc. Cash payment is not allowed. Optionally the client can make payments through Centralized Fee Collection Mechanism (CeFCoM) managed by BSE Limited (i.e. currently recognized RAASB).',
        '5. The RA is required to abide by the applicable regulations/ circulars/ directions specified by SEBI and RAASB from time to time in relation to disclosure and mitigation of any actual or potential conflict of interest. The RA will endeavor to promptly inform the client of any conflict of interest that may affect the services being rendered to the client.',
        '6. Any assured/guaranteed/fixed returns schemes or any other schemes of similar nature are prohibited by law. No scheme of this nature shall be offered to the client by the RA.',
        '7. The RA cannot guarantee returns, profits, accuracy, or risk-free investments from the use of the RA’s research services. All opinions, projections, estimates of the RA are based on the analysis of available data under certain assumptions as of the date of preparation/publication of research report.',
        '8. Any investment made based on recommendations in research reports are subject to market risks, and recommendations do not provide any assurance of returns. There is no recourse to claim any losses incurred on the investments made based on the recommendations in the research report. Any reliance placed on the research report provided by the RA shall be as per the client’s own judgement and assessment of the conclusions contained in the research report.',
        '9. The SEBI registration, Enlistment with RAASB, and NISM certification do not guarantee the performance of the RA or assure any returns to the client.',
        '10. For any grievances,',
        '    Step 1: the client should first contact the RA using the details on its website or following contact details:',
        `  Name- ${full_name || 'NA'}, Mobile No.- ${contact || 'NA'}`,
        '    Step 2: If the resolution is unsatisfactory, the client can also lodge grievances through SEBI’s SCORES platform at www.scores.sebi.gov.in',
        '    Step 3: The client may also consider the Online Dispute Resolution (ODR) through the Smart ODR portal at https://smartodr.in',
        '11. Clients are required to keep contact details, including email id and mobile number/s updated with the RA at all times.',
        '12. The RA shall never ask for the client’s login credentials and OTPs for the client’s Trading Account Demat Account and Bank Account. Never share such information with anyone including RA.',
      ];

      terms.forEach((text, index) => {
        if (marginY > 270) {
          // Check if there's enough space, else add a new page
          doc.addPage();
          marginY = 30;
        }
        const splitText = doc.splitTextToSize(text, 170);
        doc.text(splitText, marginX, marginY);
        marginY += splitText.length * reducedLineHeight;
      });

      const pdfName = `${full_name || 'Expert'}_SEBI_Disclosure.pdf`;
      doc.save(pdfName);
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },

  computed: {
    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },
    planDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },

    showTradeDialogue() {
      this.isDataChanged = this.$store.state.tradeDialogVisible ? true : false;
      return this.$store.state.tradeDialogVisible;
    },

    //returns stored user profile from local storage
    // userProfile() {
    //   return JSON.parse(localStorage.getItem("profile"));
    // },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.ExpertStore {
  min-height: 100vh;
  background-color: $page-background-color;
  padding: 60px 0 0 0;

  .background-cover {
    position: relative;
    height: 230px;
    // background: $secondary-theme-color;

    background-image: url('../assets/images/cover_bg_big.png');
    width: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .profile-card {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 25%);
    width: 90%;
    margin: auto;
    min-height: 150px;

    .inner {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .name-details {
      position: relative;
      margin-left: 150px;
      width: 650px;
    }
    .section-block {
      margin-bottom: 10px;
    }

    .left-margin-5 {
      margin-left: 5px;
    }
    .profession {
      font-size: 12px;
      font-weight: 500;
      color: #929292;
    }
    .research-info {
      font-size: 12px;
      color: #303133;
      font-weight: 500;
      white-space: normal;
    }

    .research-info span {
      display: inline;
      margin-left: 4px;
    }

    .sebi-tag {
      display: flex;
      border-radius: 8px;
      overflow: hidden;
      font-size: 12px;
      font-weight: 600;
      width: fit-content;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.05);
    }

    .sebi-left {
      background-color: #d1f8df;
      color: #20b26c;
      padding: 6px 10px;
      display: flex;
      align-items: center;
    }

    .sebi-right {
      background-color: #f4f7fe;
      color: #000;
      padding: 6px 10px;
      display: flex;
      align-items: center;
    }

    .middle-actions {
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      height: 100%;
      justify-content: space-between;
      gap: 55px;
    }

    .chat-btn {
      font-size: 12px;
      padding: 7px 10px 5px;
      background-color: #fff;
      color: #2488ff;
      border: 0.5px solid #2488ff;
      border-radius: 50px;
      font-weight: 600;
    }

    .social-icon-container {
      display: flex;
    }

    .social-icon-container .social-icon {
      height: 25px;
      margin: 0 5px;
      cursor: pointer;
      transition: transform 0.2s;
      /* Animation */
    }

    .social-icon-container .social-icon:hover {
      transform: scale(1.1);
    }
  }

  .profile-outer {
    position: absolute;
    top: -50px;
    width: 130px;
  }

  .profile-pic-section {
    height: 100px;
    width: 100px;
    border-radius: 100%;
    border: 2px solid #fff;
  }

  .profile-pic {
    height: 100px;
    width: 100px;
    object-fit: cover;
    border-radius: 100%;
  }
  .verified {
    width: 16px;
    height: 16px;
    margin-left: 5px;
  }
  .rank-wrapper {
    position: absolute;
    bottom: -12px;
    right: 0;
    left: 0;
  }

  .research-service-text {
    display: inline-block;
    font-size: 0.8rem;
    font-weight: 500;
    color: black;
    white-space: normal;
    max-width: 100%;
  }

  .expertise-wrapper {
    width: 280px;
    text-align: right;
    border-left: 0.5px solid #b5b5b5;
    padding-left: 20px;
    align-content: end;

    .expertise-title {
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 5px;
      text-align: left;
      white-space: nowrap;
      display: flex;
      justify-content: left;
    }

    .expertise-title img {
      margin: 0px 10px 5px 0px;
    }
    .expertise-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      justify-content: flex-start;
    }

    .expertise-tag {
      background-color: #ecf4ff;
      color: #2488ff;
      padding: 5px 10px;
      border-radius: 20px;
      font-size: 0.75rem;
      font-weight: 500;
      text-align: center;
      white-space: nowrap;
      margin-bottom: 5px;

      /* Flexbox for making each tag's width dynamic */
      flex: 0 1 auto;
      min-width: 70px;
      max-width: calc(50% - 8px);
    }
  }
  .rating-tag {
    background: #edeef4;
    border-radius: 6px;
    padding: 5px 12px;
    font-size: 0.7rem;
    font-weight: 500;
  }

  .performance-count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    color: $secondary-theme-color;
    font-size: 0.8rem;
    font-weight: 600;
    border-radius: 8px;
  }

  .title {
    font-size: 1rem;
    font-weight: 600;
    color: #545453;
  }

  .sub-title {
    font-size: 0.7rem;
    font-weight: 600;
    color: #000;
    // color: #545453;
  }

  .cover-page-container {
    // width: calc(100% - 265px);
    // margin-left: 265px;
    min-height: 100vh;
    // padding: 20px 20px 0 20px;
    box-sizing: border-box;
    padding-bottom: 80px;

    .line-height-1-5 {
      line-height: 1.5;
    }
  }

  .reco-card-section {
    position: relative;
    overflow: visible;
    padding-top: 50px;
  }

  .card-bg-top {
    position: absolute;
    top: 0;
    left: 5%;
    width: 90%;
    height: 90px;
    background-image: url('../assets/images/Expert Cover page chat banner.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transform: translateY(-50%);
    z-index: 1;
    border-radius: 10px;
    display: flex;
    align-items: center;
    // padding: 0 20px;
  }

  .banner-content {
    width: 100%;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    z-index: 2;
  }

  .left-content {
    display: flex;
    align-items: center;
  }

  .left-content h1 {
    font-size: 35px;
    font-weight: 800;
    margin: 0px;
  }

  .left-content p {
    font-size: 15px;
    font-weight: 600;
    margin: 0px;
  }
  .chat-icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  .left-content .highlight {
    background: linear-gradient(45deg, #00f0ff, #a259ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  /* Center UL Section */
  .middle-text {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .middle-text ul {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: left;
  }

  .middle-text li {
    font-size: 13px;
    font-weight: 600;
    margin: 4px 0;
    color: #fee65f;
  }

  .middle-text li i.el-icon-check {
    color: white;
    font-size: 15px;
    font-weight: 600;
  }
  /* Right Section */
  .right-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .ask-now {
    background: linear-gradient(90deg, #2d2e8d 0%, #2488ff 100%);
    border: none;
    padding: 8px 16px;
    border-radius: 5px;
    color: #ffffff;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
  }

  .expert-buzz-feed {
    margin-top: 20px;

    .ExpertBuzz-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      font-weight: 600;
      margin-bottom: 10px;
      padding-left: 10px;
    }

    .view-all {
      font-size: 14px;
      font-weight: 500;
      color: #2d2e8d;
      cursor: pointer;
      padding-right: 10px;
    }

    .post-details {
      height: 600px !important;
    }
  }

  .review-disclosure-wrapper {
    margin-top: 10px;
  }
  .review-section {
    .profile-pic {
      height: 38px;
      width: 38px;
      object-fit: cover;
      border-radius: 100%;
    }
  }

  .about-section {
    width: 90%;
    margin: 190px auto 0 auto;
  }
  @media screen and (max-width: 1270px) {
    .profile-card .name-details {
      width: 100%;
    }
    .about-section {
      width: 95%;
      margin: 300px auto 0 auto;
    }

    .expertise-wrapper {
      margin-left: 150px;
      border-left: none;
      padding-left: 0px;
      margin-top: 20px;
      width: auto;
    }
  }
  @media screen and (max-width: 1050px) {
    .profile-card {
      width: 95%;
    }
    .profile-card .name-details {
      width: 100%;
    }
    .expertise-wrapper {
      text-align: left;
      border-left: 0px;
    }
  }
  @media screen and (max-width: 992px) {
    .profile-card {
      width: 95%;
    }

  }

  @media screen and (max-width: 840px) {
    .middle-text {
      display: none;
    }
  }

  @media screen and (max-width: 792px) {
    .about-section {
      margin: 365px auto 0 auto;
    }
  }

  @media screen and (max-width: 530px) {
    .background-cover {
      height: 180px;
    }

    .profile-card {
      top: 20%;
    }

    .profile-card .social-icon-container .social-icon {
      height: 15px;
    }
  }


  @media screen and (max-width: 486px) {
    .about-section {
      margin: 420px auto 0 auto;
    }
    .profile-outer {
      position: relative;
      // top: -50px;
      // width: 130px;
      // margin: auto;
    }

    .profile-card .name-details {
      margin: 0;
      margin-top: -35px;
    }

    .expertise-wrapper {
      margin-left: 0px;
      padding-left: 0px;
    }

    .left-content h1 {
      font-size: 20px;
      font-weight: 800;
      margin: 0px;
    }

    .left-content p {
      font-size: 9px;
      font-weight: 500;
      margin: 0px;
    }
    .chat-icon {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .card-bg-top {
      padding: 0px;
    }

    .social-icon-container .social-icon {
      height: 15px;
    }
  }

  @media screen and (max-width: 377px) {
    .background-cover {
      height: 180px;
    }

    .profile-card {
      top: 20%;
    }

    .about-section {
      margin: 415px auto 0 auto;
    }
  }

  @media screen and (max-width: 340px) {
    .about-section {
      margin: 440px auto 0 auto;
    }
  }
}

@media screen and (max-width: 1283px) {
  .ExpertStore {
    padding: 50px 0 0 0;
  }
}
</style>

<style lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.ExpertStore {
  .expert-community-post-component .community-post {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .post-item {
      margin-bottom: 20px;
      width: 32.33%;
    }
    .post-details {
      background-color: black;
      height: 500px;
    }

    .post-media {
      position: relative;
      margin-bottom: 15px;
      height: 270px;
      border-radius: 10px;
      background: #f9f9f9;
      padding: 10px;
      overflow-y: auto;
      overflow-x: hidden;
      display: block;

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 10px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      .document-preview-wrapper {
        padding: 20px;
        background-color: #1e1e2f;
        border-radius: 10px;
        max-width: 100%;
        margin-top: 10px;
        text-align: center;
      }
    }
  }
  .profile-card {
    overflow: visible;
    box-shadow: none;
    border-radius: 10px;
  }

  .about-us-card {
    box-shadow: none;
    border-radius: 10px;
    margin: 0.5rem 0;
  }

  .review-dialog {
    .el-dialog {
      border-radius: 10px;
      width: 575px;

      .el-dialog__body {
        word-break: normal;
      }
    }
  }

  .review-dialog {
    .el-dialog {
      border-radius: 10px;
      width: 575px;

      .el-dialog__body {
        word-break: normal;
      }
    }
  }

  .el-progress__text {
    font-size: 0.6rem !important;
    color: $primary-theme-color !important;
    font-weight: 500;
  }

  .el-dialog {
    border-radius: 10px;
  }

  .el-dialog__title {
    font-size: 1rem;
    font-weight: 600;
    // color: #545453;
    color: #000;
  }

  .access-code-dialog {
    .el-dialog {
      width: 30%;
    }

    .el-dialog__body {
      padding: 10px 10px 20px 10px;
    }
  }

  .review-section {
    .review-card {
      border-radius: 10px;

      .el-card__body {
        padding: 5px 20px;
      }
    }

    .el-rate__icon {
      font-size: 14px !important;
      margin-right: 2px;
    }
  }

  .access-code-input {
    width: 200px;

    .el-input__inner {
      border-radius: 50px;
    }
  }

  .el-carousel__container {
    min-height: 450px;
  }

  .el-carousel__item.is-active {
    z-index: 0;
  }

  @media screen and (max-width: 992px) {
    // .expert-community-post-component .community-post {
    //   wid
    //   .post-item {
    //     width: 49%;
    //   }
    // }
    .access-code-dialog {
      .el-dialog {
        width: 45%;
      }
    }
  }

  @media (max-width: 768px) {
    .expert-community-post-component .community-post {
      flex-wrap: nowrap;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch; /* Smooth scrolling for iOS */
      gap: 10px;

      .post-item {
        flex: 0 0 auto;
        width: 80%; /* or any fixed width */
      }
    }
  }

  @media screen and (max-width: 650px) {
    .access-code-dialog {
      .el-dialog {
        width: 80%;
      }
    }

    .review-dialog {
      .el-dialog {
        width: 95%;
      }
    }
  }
}

.el-popover__title {
  color: #ffff;
  margin-bottom: 0;
}

.el-popover {
  min-width: 100px !important;
  background-color: #000000d3;
  border: 1px solid;
  padding: 10px 15px;
}

.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  border-style: unset;
}
</style>
